import { useMediaQueryList } from "@hooks/use-media-query";
import { Box, Stack } from "@mui/material";
import { DataManagementStep } from "@pages/data-management/data-management-stepper/data-management-step";
import { StepState } from "@pages/data-management/data-management-types";

interface Props {
  /** State of the upload step. */
  uploadStepState: StepState;
  /** State of the processing step. */
  processStepState: StepState;
  /** State of the registration step. */
  registerStepState: StepState;
  /** State of the publishing step. */
  publishStepState: StepState;
}

/** The progress stepper in Data Management. */
export function DataManagementStepper({
  uploadStepState,
  processStepState,
  registerStepState,
  publishStepState,
}: Props): JSX.Element {
  const { isMedium, isSmall, isExtraSmall } = useMediaQueryList();

  let width: string;
  if (isMedium) {
    width = "98%";
  } else if (isSmall) {
    width = "99%";
  } else if (isExtraSmall) {
    width = "90%";
  } else {
    width = "85%";
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack
        direction="row"
        sx={{
          width,
          marginLeft: "auto",
          marginRight: "auto",
          whiteSpace: "nowrap",
      }}>
        <DataManagementStep
          stepState={uploadStepState}
          titleActive="Uploading"
          titleOther="Upload"
        />
        <DataManagementStep
          stepState={processStepState}
          titleActive="Processing"
          titleOther="Process"
        />
        <DataManagementStep
          stepState={registerStepState}
          titleActive="Registering"
          titleOther="Register"
        />
        <DataManagementStep
          stepState={publishStepState}
          titleActive="Publishing"
          titleOther="Publish"
          isLastStep={true}
        />
      </Stack>
    </Box>
  );
}
